import { render } from "./PartnerCanCapital.vue?vue&type=template&id=4919c448"
import script from "./PartnerCanCapital.vue?vue&type=script&lang=js"
export * from "./PartnerCanCapital.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__